export default "__VITE_ASSET__4187b1d7__"